// 301 from the legacy /merge-pdf path to the canonical /merge (brief §1).
// Preserves SEO equity from existing inbound links and search results.
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/merge-pdf")({
  beforeLoad: () => {
    throw redirect({ to: "/merge", statusCode: 301 });
  },
});
